import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
  fill: "#FFE5D5"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m19.35 9 5.4 5.4v10.8a1.8 1.8 0 0 1-1.8 1.8h-10.8a1.8 1.8 0 0 1-1.8-1.8V10.8a1.8 1.8 0 0 1 1.8-1.8h7.2Zm3.6 16.2v-9.9h-4.5v-4.5h-6.3v14.4h10.8Zm-6.372-6.921c-.216-.693-.693-2.907.567-2.943 1.26-.036.432 2.808.432 2.808.351 1.341 1.818 2.304 1.818 2.304.45-.135 3.015-.432 2.655.9-.387 1.332-3.15.081-3.15.081-1.755.126-3.069.594-3.069.594-1.017 1.899-2.205 2.727-2.69 1.926-.604-.999 1.916-2.286 1.916-2.286 1.305-2.115 1.503-3.348 1.521-3.384Zm.585.756c-.36 1.17-1.08 2.421-1.08 2.421.765-.306 2.44-.657 2.44-.657-1.027-.9-1.342-1.755-1.36-1.764Zm2.826 1.953s1.575.585 1.611.351c.063-.243-1.197-.459-1.61-.351Zm-5.094 1.341c-.693.27-1.359 1.422-1.197 1.422.162.009.82-.54 1.197-1.422Zm2.268-4.995c0-.045.387-1.512 0-1.557-.27-.027-.009 1.521 0 1.557Z",
  fill: "#FF3B30"
});
function PdfAvatar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _ref2, _ref3);
}
export default PdfAvatar;